import { p as aclImport } from './acl-f3c6ddd0.js';
import { a as argImport } from './arg-3a1badff.js';
import { b6 as asImport } from './as-3793f0cb.js';
import { a3 as calImport } from './cal-13a8c1b1.js';
import { u as contactImport } from './contact-b66b44c5.js';
import { k as dcImport } from './dc-32eaefad.js';
import { ax as dctImport } from './dct-723b779b.js';
import { al as foafImport } from './foaf-107261f2.js';
import { h as httpImport } from './http-4a3ca0ad.js';
import { a0 as hydraImport } from './hydra-3c475ccc.js';
import { o as ldpImport } from './ldp-4e9496a5.js';
import { l as linkImport } from './link-f6e90181.js';
import { t as logImport } from './log-c975ddd5.js';
import { m as meetingImport } from './meeting-1395c9ba.js';
import { ag as owlImport } from './owl-4a437d22.js';
import { q as quImport } from './qu-12ce932a.js';
import { c as tripImport } from './trip-da5a1217.js';
import { e as rdfImport } from './rdf-755eb12b.js';
import { g as rdfsImport } from './rdfs-5548d535.js';
import { s as schedImport } from './sched-ac2bbab4.js';
import { x6 as schemaImport } from './schema-7b9aacf9.js';
import { aF as siocImport } from './sioc-3662fe90.js';
import { F as skosImport } from './skos-d7472b70.js';
import { v as solidImport } from './solid-f7e71b3b.js';
import { b as spaceImport } from './space-24f00775.js';
import { g as tabImport } from './tab-b26d587f.js';
import { g as tabontImport } from './tabont-c891a63f.js';
import { bf as vcardImport } from './vcard-b70b0c25.js';
import { Q as wfImport } from './wf-b0c00d3a.js';

var acl = aclImport;
var arg = argImport;
var as = asImport;
var cal = calImport;
var contact = contactImport;
var dc = dcImport;
var dct = dctImport;
var foaf = foafImport;
var http = httpImport;
var hydra = hydraImport;
var ldp = ldpImport;
var link = linkImport;
var log = logImport;
var meeting = meetingImport;
var owl = owlImport;
var qu = quImport;
var trip = tripImport;
var rdf = rdfImport;
var rdfs = rdfsImport;
var sched = schedImport;
var schema = schemaImport;
var sioc = siocImport;
var skos = skosImport;
var solid = solidImport;
var space = spaceImport;
var tab = tabImport;
var tabont = tabontImport;
var vcard = vcardImport;
var wf = wfImport;

export { acl, arg, as, cal, contact, dc, dct, foaf, http, hydra, ldp, link, log, meeting, owl, qu, rdf, rdfs, sched, schema, sioc, skos, solid, space, tab, tabont, trip, vcard, wf };
